export const option = (value, description, rest = {}) => ({
  value,
  description: description || value,
  ...rest,
})
